<template>
  <div fluid class="full-screen-background">
    <v-container>
      <v-row>
        <v-col>
          <h1>
            <span style="color:#03A9F4;">专业</span>
            <span>信赖，</span>
            <span style="color:#03A9F4;">携手</span>
            <span>成长</span>
          </h1>
          <p>以信为本 以诚立业 规范务实 追求专业</p>
        </v-col>
      </v-row>

      <!-- 右下角的行业链接区域 -->
      <v-row class="fixed-bottom-right">
        <v-col cols="auto">
          <v-card class="news-card" width="450" height="300" outlined>
            <v-card-title>行业动态</v-card-title>
            <v-card-text>
              <v-list>
                <v-list-item v-for="(link, index) in links" :key="index" :href="link.url" target="_blank">
                  {{ link.title }}
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script setup>
import { ref } from 'vue'
const links = ref([
  {
    title: '关于开展2025年度享受增值税加计抵减政策的集成电路企业清单制定工作的通知',
    url: 'https://shanghai.chinatax.gov.cn/zcfw/zcfgk/zzs/202509/t477729.html'
  },
  {
    title: '关于办理增值税期末留抵退税有关征管事项的公告',
    url: 'https://shanghai.chinatax.gov.cn/zcfw/zcfgk/zzs/202508/t477460.html'
  },
  {
    title: '关于推广应用电子凭证会计数据标准的通知',
    url: 'https://www.cicpa.org.cn/xxfb/tzgg/202505/t20250519_65433.html'
  },
  {
    title: '关于开展2025年上海市注册会计师行业岗位技能比武竞赛的通知',
    url: 'https://www.shcpa.org.cn/info/?pid=7003'
  }
])

</script>

<style scoped>
p {
  padding-left: 10px;
  font-size: 24px;
  font-weight: 300;
  line-height: 1.5;
  color: gray;
}

h1 {
  padding: 20px 30px 20px 0px;
  font-size: 4rem;
  font-weight: bold;
  color: #E1F5FE;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.full-screen-background {
  background-image: url('/public/assets/img/GGI1_c12a2c12a2c12a2c.png');
  background-size: cover;
  background-position: center;
  background-color: #f8f9fa;
  background-repeat: no-repeat;
  background-attachment: fixed;
  height: calc(100vh - 104px);
  width: 100vw;
  padding: 0;
  margin: 0;
}

.fixed-bottom-right {
  position: fixed;
  bottom: 60px;
  left: 20px;
}

.news-card {
  background: rgba(255, 255, 255, 0.8);
  /* 半透明背景 */
  backdrop-filter: blur(10px);
  /* 磨砂效果 */
  border-radius: 8px;
  /* 圆角 */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  /* 阴影效果 */
}

.v-list {
  background: none;
}
</style>